import React, { useState } from "react";
import { useMenuContext } from "../store/order_context";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomArrow from "./CustomArrow";
import IconComponent from "./IconComponent";

const Categories = (props) => {
  const { setSubCategoryID, chosenCategory, subCategoryID, setActiveMenusubCategory, activeMenusubCategory } = useMenuContext();

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />
  };

  return (
    <div className="slider">
      <Slider {...settings}>
        {chosenCategory && chosenCategory.map((cat) => (
          <div key={cat.categoryID} className={`${activeMenusubCategory === cat.categoryID ? 'item active' : 'item'}`}>
            <a 
              onClick={() => {
                setSubCategoryID(cat.categoryID);
                setActiveMenusubCategory(cat.categoryID);
              }}
            >
              <IconComponent image={cat.categoryImage} />
              <h4>{cat.categoryName}</h4>
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Categories;
